<template>
  <div class="goods-remark">
    <div class="title">{{ $t('product.remark') }}</div>
    <el-input class="input" type="textarea" :rows="3" v-model="searchVal"
      :placeholder="$t('product.holder.remarkHolder')"></el-input>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue';

const $emit = defineEmits(['update:value']);
const $props = defineProps({
  value: {
    type: String,
    default: ''
  }
});
const searchVal = computed({
  get() {
    return $props.value;
  },
  set(val) {
    $emit('update:value', val);
  }
});
</script>

<style lang="scss" scoped>
.goods-remark {
  padding-bottom: 12px;

  // border-bottom: 1px solid var(--line-light-gray-color);
  .title {
    font-family: Montserrat;
    font-size: 18px;
    font-weight: bold;
    line-height: normal;
    text-transform: capitalize;
    letter-spacing: 0em;
    color: var(--black-color-9);
    margin-bottom: 12px;
  }

  .input {
    ::v-deep(.el-textarea__inner) {
      padding: 16px 19px 16px 25px;
      font-family: Montserrat;
      font-size: 14px;
      font-weight: normal;
      line-height: 21px;
      text-transform: capitalize;
      letter-spacing: 0em;
      // color: $gray-color;
      border: 1px solid var(--border-da);
    }
  }
}
</style>
